<template>
	<div style="overflow-x: hidden !important">
		<div style="display: flex; flex-direction: column" v-if="idx === undefined">
			<!-- SIDEBAR -->
			<div class="menu" :style="{ width: sidebar ? '' : '75px' }">
				<button-collapse-sidebar :open="sidebar" @change="sidebar = !sidebar" />
				<folders-sidebar :open="sidebar" />
			</div>

			<div class="main" :style="{ width: widthscreen, marginLeft: !sidebar ? '75px' : '150px' }">
				<div style="padding: 10px; margin-top: 15px">
					<app-breadcrumb :history="breadcrumb" @mutate="doMutate" />
					<div class="header">
						<div class="header_title-container title">
							<h1>{{ $t("folders") }}</h1>
							<h5>{{ computedFolNumber }}</h5>
						</div>
						<div class="header_actions">
							<div class="header_actions-container">
								<el-button
									icon="el-icon-plus"
									@click="
										selected_folder = undefined
										addEditFolderPopup = true
									"
									type="success"
									plain
								>
									{{ $t("new-folder") }}
								</el-button>

								<search
									:loadDocs="false"
									:loadFolders="true"
									:folderID="undefined"
									from="folders-layout"
									@docSelected="item => {}"
									@folderSelected="
										item => {
											goto('/documents/folders/' + item.id)
										}
									"
									@keyup="
										str => {
											handleSearch(str)
										}
									"
								/>
							</div>
						</div>
					</div>

					<div class="documents infinite-list-wrapper" style="overflow: auto">
						<div
							class="documents_container list"
							v-infinite-scroll="scrollLoad"
							:infinite-scroll-disabled="scrollDisabled"
							infinite-scroll-distance="50"
							style="margin-bottom: 100px"
						>
							<div class="documents_wrapper" @click="goto('/documents/folders/0')">
								<div class="documents_upper">
									<div class="documents_thumb">
										<div style="display: flex; height: 100%; overflow-x: hidden">
											<md-icon class="md-size-5x" style="color: #fbbc04">folder</md-icon>
											<div
												style="
													position: absolute;
													top: 52%;
													left: 93%;
													transform: translate(-50%, -50%);
													font-size: 2rem;
													color: #fff;
												"
											>
												{{ genericNumber }}
											</div>
										</div>
									</div>
								</div>
								<div class="documents_details">
									<div class="documents_details-infos">
										<div class="documents_details-title">{{ $t("no-folder-generic") }}</div>
									</div>
								</div>
							</div>

							<div
								v-for="d in folder"
								:key="d.id"
								@click="goto('/documents/folders/' + d.id)"
								class="documents_wrapper list-item"
							>
								<div class="documents_upper">
									<div class="documents_thumb">
										<div style="display: flex; height: 100%; overflow-x: hidden">
											<md-icon class="md-size-5x" style="color: #fbbc04">folder</md-icon>
											<div
												style="
													position: absolute;
													top: 52%;
													left: 96%;
													transform: translate(-50%, -50%);
													font-size: 2rem;
													color: #fff;
												"
											>
												{{ d.count }}
											</div>
										</div>
									</div>
								</div>
								<div class="documents_details">
									<div class="documents_details-infos">
										<div class="documents_details-title">{{ d.name }}</div>
										<div class="documents_details-subtitle">{{ d.description.String }}</div>
									</div>
									<div>
										<el-tag
											v-for="area in d.areas"
											:key="d.id + area.id"
											style="margin-left: 3px; margin-bottom: 3px"
											type="success"
										>
											{{ area.area.name }}
										</el-tag>
										<el-tag
											v-for="tag in d.tags"
											:key="d.id + tag.id"
											style="margin-left: 3px; margin-bottom: 3px"
										>
											{{ tag.tag.name }}
										</el-tag>
									</div>
									<div class="documents_details-infos2">
										<div>
											<md-button
												@click="
													$event.stopPropagation()
													$event.preventDefault()
													selected_folder = d
													deleteFolderPopup = true
												"
												class="md-icon-button"
											>
												<md-icon>delete</md-icon>
												<md-tooltip md-direction="bottom">{{ $t("delete") }}</md-tooltip>
											</md-button>
										</div>
										<div>
											<md-button @click="e => renameFolder(e, d)" class="md-icon-button">
												<md-icon>drive_file_rename_outline</md-icon>
												<md-tooltip md-direction="bottom">{{ $t("rename") }}</md-tooltip>
											</md-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="float-center">
						<div class="float-content-spinner" v-if="scrollLoading">
							<i class="el-icon-loading" />
						</div>
						<div
							class="float-content"
							v-bind:class="{ visible: scrollNoMoreSnackbar, hidden: !scrollNoMoreSnackbar }"
						>
							<div class="float-text">{{ $t("no-more-folders") }}</div>
						</div>
					</div>

					<add-edit-folder
						:show="addEditFolderPopup"
						:folder="selected_folder"
						@close="p => afterAddEdit(p)"
					/>

					<delete-confirm-modal
						:show="deleteFolderPopup"
						:title="$t('folders-delete')"
						:content="$t('folders-delete2')"
						@close="deleteFolder"
					/>
				</div>
			</div>
		</div>

		<flowchart-layout :idroute="idx" :key="idx" v-else></flowchart-layout>
	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import axios from "axios"
import { goto } from "@/utils/utils"
import AddEditFolder from "@/modules/documents/components/add-edit-folder"
import FlowchartLayout from "@/modules/flowcharts/flowchart-layout"
import ButtonCollapseSidebar from "@/modules/_common/button/button-collapse-sidebar.vue"
import FoldersSidebar from "@/modules/documents/components/sidebar-components/folders-sidebar.vue"
import AppBreadcrumb from "@/modules/_common/app-breadcrumb.vue"
import OptionButton from "@/modules/_common/button/option-button.vue"
import DeleteConfirmModal from "@/modules/_common/modal/delete-confirm-modal.vue"
import Search from "@/modules/documents/components/search.vue"

export default {
	name: "folders-layout",
	components: {
		AddEditFolder,
		FlowchartLayout,
		AppBreadcrumb,
		OptionButton,
		DeleteConfirmModal,
		Search,
		"button-collapse-sidebar": ButtonCollapseSidebar,
		"folders-sidebar": FoldersSidebar
	},
	data() {
		return {
			folderSearch: "",
			folder: [],
			folderNumber: "",
			genericNumber: undefined,
			selected_folder: null,
			addEditFolderPopup: false,
			deleteFolderPopup: false,
			idx: undefined,

			sidebar: true || window.innerWidth < 900,
			widthscreen: window.innerWidth - 150,
			heightscreen: window.innerHeight,
			mobile: window.innerWidth < 900,

			scrollLoading: false,
			scrollNoMoreSnackbar: false,
			scrollEnded: false,
			tilesNumber: 1,
			rowsToLoad: 4,
			loadedPages: 0
		}
	},
	created() {
		this.tilesNumber = Math.floor((this.widthscreen - 90) / 340)
		this.getFolders()
	},
	watch: {
		scrollNoMoreSnackbar() {
			if (this.scrollNoMoreSnackbar) {
				setTimeout(() => {
					this.scrollNoMoreSnackbar = false
				}, 3000)
			}
		}
	},
	computed: {
		...mapGetters({
			breadcrumb: "documents/breadcrumb"
		}),
		computedFolNumber: function () {
			return this.$t("folders-counter").replace("%DOCSNUMBER%", this.folderNumber)
		},
		scrollDisabled() {
			return this.scrollLoading || this.scrollEnded
		}
	},
	methods: {
		...mapActions({
			doMutate: "documents/doMutate"
		}),
		scrollLoad() {
			this.loadedPages++
			this.getFolders()
		},
		handleSearch(str) {
			this.folderSearch = str
			this.reload()
		},
		reload() {
			this.loadedPages = 0
			this.scrollEnded = false
			this.scrollLoading = false
			this.scrollNoMoreSnackbar = false
			this.folder = []
			this.getFolders()
		},
		getFolders() {
			if (!this.scrollEnded) {
				this.scrollLoading = true

				var payload = {
					pagination: {
						offset: this.loadedPages * this.tilesNumber * this.rowsToLoad,
						size: this.rowsToLoad * this.tilesNumber
					},
					search: this.folderSearch.toLowerCase()
				}

				if (payload.pagination.offset == 0) {
					//primo load, ne carico uno di meno perché c'è la folder senza procedura
					payload.pagination.size -= 1
				} else {
					//load successivi, ne carico il numero giusto ma con offset -1 per compensare
					payload.pagination.offset -= 1
				}

				axios
					.post(process.env.VUE_APP_API_URL + "/api/folders/getFolders", payload, {
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					})
					.then(res => {
						this.folderNumber = res.data.total
						this.genericNumber = res.data.generic

						//quando items non esiste, length torna errore e viene eseguito il catch
						//è giusto, lasciarlo così
						for (let i = 0; i < res.data.items.length; i++) {
							const c = res.data.association.find(x => x.Id === res.data.items[i].id)
							this.folder.push({
								id: res.data.items[i].id,
								name: res.data.items[i].name,
								description: res.data.items[i].description,
								areas: res.data.items[i].areas,
								tags: res.data.items[i].tags,
								count: c.Count
							})
						}
						this.scrollLoading = false
					})
					.catch(err => {
						this.scrollLoading = false
						this.scrollNoMoreSnackbar = true
						this.scrollEnded = true
					})
			} else {
				this.scrollNoMoreSnackbar = true
			}
		},
		goto,
		renameFolder(e, d) {
			e.stopPropagation()
			e.preventDefault()
			this.selected_folder = d
			this.addEditFolderPopup = true
		},
		afterAddEdit(p) {
			if (p) {
				if (this.selected_folder) {
					this.selected_folder.name = p.name
					this.selected_folder.description.String = p.description
					this.selected_folder.areas = p.areas
					this.selected_folder.tags = p.tags
				} else {
					this.reload()
				}
			}
			this.selected_folder = undefined
			this.addEditFolderPopup = false
		},
		deleteFolder: function (doDelete) {
			if (doDelete) {
				axios
					.post(
						process.env.VUE_APP_API_URL + "/api/folders/deleteFolder",
						{ id: this.selected_folder.id },
						{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
					)
					.then(res => {
						let index = -1
						for (let i = 0; i < this.folder.length; i++) {
							if (this.folder[i].id == this.selected_folder.id) {
								index = i
								break
							}
						}
						if (index != -1) this.folder.splice(index, 1)

						this.$notification("success", this.$t("deleted-successfully"), "", 4500)
					})
					.catch(err => {
						this.$processError(this.$t("delete-error"), err.response.data.Message)
					})
			}
			this.deleteFolderPopup = false
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/collapse-button";
.main {
	margin-top: -25px;
}

.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	left: 0;
	bottom: 0;
	top: 63px;
	width: 150px;
	background-color: #455a64;
	transition: width 0.5s;
}

.item {
	padding: 17px 10px;
	cursor: pointer;
	color: #cfd8dc;
	width: 100%;
	&:hover {
		border-left: 3px solid #6ff9ff;
	}
	display: flex;
	.md-icon {
		margin-left: 5px;
		margin-right: 5px;
	}
	span {
		margin-top: auto;
		margin-bottom: auto;
	}
}

.item-selected {
	border-left: 3px solid #6ff9ff;
	color: white;
	background-color: rgba(127, 127, 127, 0.1);
}

.selected {
	color: #6ff9ff;
}

.float-content-spinner {
	width: 50px;
	height: 50px;
	font-size: 40px;
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
	padding-top: 5px;
	transform: translate(-25px);
}

.float-content {
	width: 300px;
	height: 30px;
	transform: translate(-150px);
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
}

.visible {
	visibility: visible;
	opacity: 1;
}

.hidden {
	visibility: hidden;
	opacity: 0;
	transition: visibility 0s 1s, opacity 1s linear;
}

.float-text {
	padding-top: 5px;
}
</style>
